import { adminHttpClient } from '../commons/adminHttpClient'
import BenefitParticipationDecision from '../../domain/companies/BenefitParticipationDecision'
import { Moment } from 'moment'

export type MakeOptInOptOutDecisionRequest = {
  planPeriodId: string
  decision: BenefitParticipationDecision
  companyUserId?: string
  effectiveDate?: Moment
}
const makeOptInOptOutDecision = (request: MakeOptInOptOutDecisionRequest): Promise<void> => {
  return adminHttpClient.post(`/EEDashboard/MakeDecision`, request)
}

export default makeOptInOptOutDecision
